$(document).ready(function () {
    setTimeout(function () {
        initObservers()
    }, 500);
})

const productSwiperClass = isMobile ? '.items-gallery'
    : ((pageType === 'CART') ? '#merchandisingDataProducts' : ((pageType === '') ? '' : '.product-swiper'))
var lobby = {}

function initObservers() {

    if (isMobile) {
        lobby.secondaryBanner = document.querySelector('.banner-box')
    } else if ($('#home-boxes').length) {
        lobby.secondaryBanner = document.querySelector('#merchandisingDataProducts .banner-box')
    }

    lobby.observerSecondaryBanner = new IntersectionObserver(handleIntersection)
    if (lobby.secondaryBanner) {
        lobby.observerSecondaryBanner.observe(lobby.secondaryBanner)
    }

    if (!impressionsAsync || impressionsAsync.length === 0) return
    impressionsAsync.forEach(function(obj) {
        lobby[`selector_${obj.item_id}`] = $(`${productSwiperClass} div[data-id=${obj.item_id}]`)[0]
        lobby[`observer_${obj.item_id}`] = new IntersectionObserver(handleIntersection)
        if (lobby[`selector_${obj.item_id}`]) {
            lobby[`observer_${obj.item_id}`].observe(lobby[`selector_${obj.item_id}`])
        }
    })
}
function handleIntersection(entries) {
    entries.map(function (entry) {
        if (entry.isIntersecting) {
            if (entry.target == lobby.secondaryBanner) {
                secondaryBannerImpressions()
                lobby.observerSecondaryBanner.unobserve(lobby.secondaryBanner)
            } else {
                var id = entry.target.dataset.id
                sendAsyncImpressions(id)
                lobby[`observer_${id}`].unobserve(lobby[`selector_${id}`])
            }
        }
    })
}
